import script from "./PartnerManagementMain.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerManagementMain.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/account.css?vue&type=style&index=0&id=16b45cf7&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b45cf7"]])

export default __exports__